import { render, staticRenderFns } from "./SkinToneModal.vue?vue&type=template&id=7a4d062c"
import script from "./SkinToneModal.vue?vue&type=script&lang=js"
export * from "./SkinToneModal.vue?vue&type=script&lang=js"
import style0 from "./SkinToneModal.vue?vue&type=style&index=0&id=7a4d062c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports